module.exports = __webpack_public_path__ + "img/3.5427c19c.jpg";